import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useParams } from "react-router";
import Rectangle2 from "../../static/img/Rectangle2.png"
import { getevent, getparent, getmyevents, getsystemlis, gethome, goto, papticipants, goevent, eventperson, getwhether, getperson, recommendations, getindustryType } from '../../utils/api'
import { gettime, gettime2 } from '../../utils/time'
import { Cell, } from '@nutui/nutui-react';
import { Toast } from 'zarm';
import { InfiniteScroll } from 'antd-mobile'
import SdmClientSDk, { PlatformType } from 'sdm-js-sdk';
import VConsole from 'vconsole';
import { getPlatformInfo } from '../../utils/getPlatformInfo'
import { PROJECT_NAME } from '../../utils/constants'
import axios from "axios";
import { cardurl } from '../../utils/constants'
import { divide, head } from 'lodash';
import { devUseWarning } from 'antd/es/_util/warning';
import bg1 from '../../static/bg/card_image_1_0.png'
import bg2 from '../../static/bg/card_image_2_0.png'
import bg3 from '../../static/bg/card_image_3_0.png'
import bg4 from '../../static/bg/card_image_4_0.png'
import Loading2 from '../../static/img/lo.png'
import { Skeleton } from 'zarm';
import { IconFont } from '@nutui/icons-react-taro'

const icon = {
    width: '14px',
    height: '14px',
    marginLeft: '5px',
    marginRight: '5px',
}

const bgc = {
    backgroundColor: '#202225',
}
const bgc2 = {
    backgroundColor: '#0E1114',
}
const tab = {
    color: '#fff',
    height: '42px',
    lineHeight: '42px',
    borderBottomRightRadius: '10px',
    backgroundColor: "#0E1114",
    paddingBottom: '10px'
    , cursor: 'pointer'
}
const tabs = {
    color: '#fff',
    backgroundColor: '#202225',
    height: '42px',
    lineHeight: '42px',
    borderTopRightRadius: '10px',
    borderTopLeftRadius: '10px',
    paddingBottom: '10px',
    fontSize: '18px'
    , cursor: 'pointer',
    fontWeight: 700

}
const tabbg = {
    flex: 1,
    backgroundColor: "#0E1114",
    fontSize: '18px'
    , cursor: 'pointer'
}
const tabbgs = {
    flex: 1,
    backgroundColor: "#202225",
    fontSize: '18px',
    cursor: 'pointer'
}
const tab2 = {
    color: '#fff',
    height: '42px',
    lineHeight: '42px',
    borderBottomLeftRadius: '10px',
    backgroundColor: "#0E1114",
    fontSize: '18px',
    paddingBottom: '10px'
    , cursor: 'pointer'
}
const h = {
    height: '100vh'
}
const Selected = {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#735BF2',
    borderRadius: '5px',
    display: 'flex',
    height: '32px',
    fontWeight: 750,
    cursor: 'pointer'
}
const notselected = {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    display: 'flex',
    fontWeight: 400,
    height: '32px'
    , cursor: 'pointer'
}
const blue = {
    borderLeft: '10px solid #4AABEC',
    color: '#4AABEC',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'

}
const pink = {
    borderLeft: '10px solid #E21CAE',
    color: '#E21CAE',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}
const green = {
    borderLeft: '10px solid #6AEC87',
    color: '#6AEC87',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}
const yellow = {
    borderLeft: '10px solid #FFC932',
    color: '#FFC932',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}
const orange = {
    borderLeft: '10px solid #FD8B86',
    color: '#FD8B86',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}






const EventDetails: React.FC = (props) => {
    const { t } = useTranslation()
    const params = useParams()
    const [search, setsearch] = useSearchParams()
    let [event, getevents] = useState([]) as any;
    const [ogList, geogList] = useState([]) as any;
    const [activity, getactivity] = useState([]) as any;
    const [tit, settit] = useState(true)
    const [tit2, settit2] = useState(true)
    const [eventId, seteventId] = useState(search.get("eventId"));
    const [eventCountry, seteventCountry] = useState(search.get("country"));
    // const [papticipant, setpapticipant] = useState([]) as any;
    // let papticipantRef = useRef([]) as any;

    const [businessCard, setbusinessCard] = useState([]) as any;
    let businessCardRef = useRef([]) as any;

    const [sys, setsys] = useState([]) as any;
    let sysRef = useRef([]) as any;

    useEffect(() => {
        businessCardRef.current = businessCard
    }, [businessCard])

    useEffect(() => {
        sysRef.current = sys
    }, [sys])


    const Directions = (url: string) => {

        if (url === null) {
            Toast.show(t('Notyetstarted'));
        } else {
            // window.location.assign(url);
            window.open(url);
        }
    };

    let [total, settotal] = useState(0)
    let totalref = useRef(total);

    useEffect(() => {
        totalref.current = total
    }, [total])

    let [sysstatus, setsysstatus] = useState([]) as any
    let sysstatusref = useRef(sysstatus);

    useEffect(() => {
        sysstatusref.current = sysstatus
    }, [sysstatus])

    const systemlis = async () => {
        await getsystemlis('sys_event_status').then((res) => {
            getDate2(res.data)
            sysstatusref.current = res.data
            setsysstatus(sysstatusref.current)
        }
        );
    }





    const getRoomInfo = (url: string) => {


        // console.log(localStorage.getItem('mx_access_token'))
        // axios({
        //     method: 'Post',
        //     url: 'https://test.semperfortis1996.com:8443/_api/client/r0/createRoom',
        //     headers: {
        //         Authorization:
        //             "Bearer siT76DbjdQt7rvsI7h5Gu9YvX6Wco3USbyn0BPJ0AmM"
        //     },
        //     data: {
        //         creation_content: {
        //             "m.federate": false
        //         },
        //             preset:"private_chat",
        //             visibility:"private",
        //     }
        // }).then(function (res) {
        //     console.log(res)
        //   axios({
        //     method: 'Post',
        //     url: 'https://test.semperfortis1996.com:8443/_api/client/v3/join/'+'!AaoWtp7zKVOkbs5x-@sdn_f30faa700b335bbe9b8d8d2e44d51228bb67ea88:f30faa700b335bbe9b8d8d2e44d51228bb67ea88',
        //     headers: {
        //         Authorization:
        //             "Bearer siT76DbjdQt7rvsI7h5Gu9YvX6Wco3USbyn0BPJ0AmM"
        //     },
        //     data: {
        //         reason: "Looking for support",
        //         third_party_signed: {
        //             mxid: "@sdn_f30faa700b335bbe9b8d8d2e44d51228bb67ea88:f30faa700b335bbe9b8d8d2e44d51228bb67ea88",
        //             sender: "@sdn_5e071cf0d804c6af770fb29d208bddf513f2a123:5e071cf0d804c6af770fb29d208bddf513f2a123",
        //             signatures: {
        //                 'example.org': {
        //                     'ed25519:0': "some9signature"
        //                 }
        //             },
        //             token: "random8nonce"
        //         }
        //     }
        // }).then(function (res) {
        //     console.log(res)
        // })

        // })


        // window.location.href = "www.baidu.com";
        // console.log('www.baidu.com')

        if (url === null) {
            Toast.show(t('Therearecurrentlynogroupchatsavailable'));
        } else {
            // window.location.assign(url);
            window.open(url);
        }
    };

    const getDate2 = async (data: any) => {


        await goevent({
            eventId: eventId,
            sdmUserId: sdmUserIdref.current
        }).then((res) => {

            data.forEach((item: any) => {
                res.data.forEach((item2: any) => {
                    if (item2.eventType == item.dictValue) {
                        item2.status = item.dictLabel
                    }
                })
            });

            let color = ['4AABEC', 'E21CAE', 'FD8B86', 'FD8D10', 'FFC932', '6AEC87', '76A534', '9F6FFF', 'E97190', '7483C4']
            res.data.forEach((item: any) => {
                item.eventcolors = color[Number(item.eventType) - 1]
                item.time = gettime2(item.eventStartTime, item.eventEndTime)
            });
            getactivity(res.data)
        }
        );
    }


    const [upcoming, getupcoming] = useState([]) as any;
    let upcomingRef = useRef([]) as any;
    useEffect(() => {
        upcomingRef.current = upcoming
    }, [upcoming])

    const [currentnum, setcurrent] = useState(0);

    let currentRef = useRef([]) as any;
    useEffect(() => {
        currentRef.current = currentnum
    }, [currentnum])

    let [types, settypes] = useState(0)

    let typesRef = useRef(0);
    useEffect(() => {
        typesRef.current = types
    }, [types])

    const getDate3 = async (state: number) => {
        const setdge = setInterval(function () {
            transformdegRef.current = transformdegRef.current * 1 + 20
            settransformdeg(transformdegRef.current)
            console.log(transformdegRef.current)
        }, 100);

        setHasMore(true)
        currentRef.current = currentRef.current + 1
        typesRef.current = state
        setshowhasMore(true)
        await gethome({
            pid: eventId,
            // eventCountry: eventCountry,
            state: typesRef.current,
            // pageNum: 1,
            current: currentRef.current,
            pageSize: 10
        }).then((res) => {
            let data = geif()
            settotal(res.total)



            if (res.rows.length > 0) {
                res.rows.forEach((item: any, index: any) => {
                    console.log(sysstatusref.current)
                    sysstatusref.current.forEach((item2: any) => {
                        if (item.eventType == item2.dictValue) {
                            item.status = item2.dictLabel
                        }
                    });


                    item.time = gettime2(item.eventStartTime, item.eventEndTime)
                    item.sdmUsers.forEach((i: any) => {
                        i.c = color16()
                        i.imgUrl = i.imgUrl + ''
                    })

                    item.people = 0
                    eventperson({
                        linUserIds: data,
                        eventId: item.eventId
                    }).then((re) => {




                        if (re.data) {
                            item.people = re.data.friends
                        }
                        if (index == res.rows.length - 1) {
                            let tmp = upcomingRef.current
                            tmp.push(...res.rows)
                            getupcoming([...tmp])
                            setHasMore(true)

                            if (res.total > upcomingRef.current.length) {
                                setHasMore(true)
                            } else {
                                setHasMore(false)
                            }
                        }
                    }
                    );
                });
            } else {
                console.log(111)
                setshowhasMore(false)
                setHasMore(false)
                return false
            }
        }
        );
        clearTimeout(setdge);
    }


    const geif = () => {
        const data: any = []
        let data2: any = []
        data2 = localStorage.getItem('getMyContacts')
        data2 = JSON.parse(data2)
        let Frienddata = data2 ? data2 : []
        if (Frienddata.length > 0) {

            data2.forEach((item: any) => {
                data.push(item.userId)
            })
        }
        return data
    }



    const [showhasMore, setshowhasMore] = useState(false)
    const [customerType, setcustomerType] = useState('')


    const papticipantsData = async (eventId: any) => {

        setshowhasMore(true)
        currentRef.current = currentRef.current + 1
        let a = ''
        await getperson(eventId, {
            // eventId:eventId,
            current: currentRef.current,
            pageSize: 10
        }).then((res) => {

            // await getperson(eventId).then((res) => {
            if (res.data) {
                setcustomerType(res.data.customerType)
                // getuserinformation(res.data)
                let data2: any = []
                data2 = localStorage.getItem('getMyContacts')
                data2 = JSON.parse(data2)
                let Frienddata = data2 ? data2 : []

                res.data.businessCard.forEach((item2: any) => {
                    item2.color = color16()

                    console.log(item2.layoutType, 'layoutType')
                    if (item2.layoutType == "1") {
                        item2.bgimg = bg1
                        console.log(item2.bgimg, 'console.log(item2.bgimg)')
                        // item2.bgimg = 'https://businesscard.socialswap.com/image/icon/card_image_1_0.png'
                    } else if (item2.layoutType == "3") {
                        item2.bgimg = bg2
                        console.log(item2.bgimg, 'console.log(item2.bgimg)')
                        // item2.bgimg = 'https://businesscard.socialswap.com/image/icon/card_image_2_0.png'
                    } else if (item2.layoutType == "5") {
                        item2.bgimg = bg3
                        console.log(item2.bgimg, 'console.log(item2.bgimg)')
                        // item2.bgimg = 'https://businesscard.socialswap.com/image/icon/card_image_3_0.png'
                    } else if (item2.layoutType == "7") {
                        item2.bgimg = bg4
                        console.log(item2.bgimg, 'console.log(item2.bgimg)')
                        // item2.bgimg = 'https://businesscard.socialswap.com/image/icon/card_image_4_0.png'
                    }


                    item2.userImg = item2.userImg + ''
                    Frienddata.forEach((item: any) => {
                        if (item.userId == item2.linxUserId) {
                            item2.friend = 1
                        }
                        if (item.walletAddress == item2.userAddress) {
                            item2.friend = 1
                        }
                        

                    })
                });

                res.data.sys.forEach((item2: any) => {
                    Frienddata.forEach((item: any) => {
                        item2.color = color16()
                        item2.imgUrl = item2.imgUrl + ''
                        if (item2.imgUrl == undefined || item2.imgUrl == null || item2.imgUrl == 'null' || item2.imgUrl == 'undefined')
                            item2.imgUrl = ''
                        if (item.userId == item2.linxUserId) {
                            item2.friend = 1
                        }
                        if (item.walletAddress == item2.walletDdressEtamask) {
                            item2.friend = 1
                        }
                        
                    })
                });

                // console.log(res.data)

                if (res.data.businessCard.length > 0 || res.data.sys.length > 0) {



                    let tmp = businessCardRef.current
                    tmp.push(...res.data.businessCard)
                    setbusinessCard([...tmp])

                    console.log('setbusinessCard', tmp)
                    






                    let tmp2 = sysRef.current
                    tmp2.push(...res.data.sys)
                    // for (let i = 0; i < 10; i++) { //删除

                    //     tmp2.push(...res.data.sys)
                    //     console.log(tmp2)
                    // }

                    setsys([...tmp2])

                    setHasMore(true)
                    setshowhasMore(false)
                } else {
                    setHasMore(false)
                    setshowhasMore(false)
                    return false
                }
            } else {

            }
        })
    }





    const getDate = async () => {
        const setdge = setInterval(function () {
            transformdegRef.current = transformdegRef.current * 1 + 20
            settransformdeg(transformdegRef.current)
            console.log(transformdegRef.current)
        }, 100);

        businessCardRef.current = []
        setbusinessCard(businessCardRef.current)

        sysRef.current = []
        setsys(sysRef.current)


        await getevent({
            id: eventId,
            userid: sdmUserIdref.current
        }).then((res) => {

            if (res.data.event.industryId) {
                getindustryType({
                    industryId: res.data.event.industryId
                }).then((re) => {
                    res.data.event.industryLabel = re.data.industryName
                })
            }


       


            res.data.event.time = gettime(res.data.event.eventStartTime, res.data.event.eventEndTime)

            if(res.data.event.eventBanner)
            res.data.event.eventBanner = res.data.event.eventBanner.replace('http:','https:')

            if (res.data.finish) {
                Toast.show(t('Thecurrentactivityhasended'));
            }



            if(res.data.event.keywords){
                let arr = res.data.event.keywords.split('##')
                res.data.event.keywordsmap = arr
            }

            sysstatusref.current.forEach((item: any) => {
                console.log('1')
                if (item.dictValue == res.data.event.eventType) {
                    console.log(item.dictLabel,'dictLabel')
                    res.data.event.state = item.dictLabel
                }
            })
            
            getevents(res.data.event)
            res.data.ogList.forEach((item: any) => {
                item.headImg = item.headImg.replace('http:','https:')
            })
            geogList(res.data.ogList)
            // getgo(res.data.go)

            papticipantsData(res.data.event.eventId)

            whether()
            // person()
            setLOADING(false)
            clearTimeout(setdge);
        }
        );
    }

    function debounce(func: any, wait: any) {
        var timeout: any;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };

    }

    const [transformdeg, settransformdeg] = useState(0)
    let transformdegRef = useRef(0);
    useEffect(() => {
        transformdegRef.current = transformdeg
    }, [transformdeg])






    useEffect(() => {
        document.body.style.overflow = 'auto'
        window.scrollTo(0, 0);
        systemlis()
        getDate()





        document.addEventListener('scroll', scrollEvent)
        return () => {
            document.removeEventListener('scroll', scrollEvent);
            // clearTimeout(timerId);
        };
    }, []);

    const getparentDate = async () => {
        if (tabSelected == 0) {
            currentRef.current = 0
            setcurrent(currentRef.current)
            tabSelectedRef.current = 1
            getSelected(tabSelectedRef.current)
            console.log(currentRef.current)
            settotal(0)
            getDate3(0)
        }

    }

    const getparentDate2 = async () => {
        if (tabSelected == 1) {
            tabSelectedRef.current = 0
            getSelected(tabSelectedRef.current)
            currentRef.current = 0
            setcurrent(currentRef.current)
            settotal(0)
            businessCardRef.current = []
            setbusinessCard(businessCardRef.current)

            sysRef.current = []
            setsys(sysRef.current)
            // getDate3(0)
            papticipantsData(eventId)
        }

    }


    const color16 = () => {
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        // var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
        var color = 'rgb(' + r + ',' + g + ', ' + b + ')';
        return color
    }



    const [bespeak, getbespeak] = useState(false);
    const [bespeak2, getbespeak2] = useState(true);
    const [tabSelected, getSelected] = useState(0);

    let tabSelectedRef = useRef(tabSelected);
    const [tabSelected2, getSelecte2] = useState(0);
    const [go, getgo] = useState(false);
    const [whitescreen, getwhitescreen] = useState(true);
    const [LOADING, setLOADING] = useState(true);

    const [sdmUserId, setsdmUserId] = useState('');
    let sdmUserIdref = useRef('')
    useEffect(() => {
        sdmUserIdref.current = sdmUserId
    }, [sdmUserId])


    useEffect(() => {
        tabSelectedRef.current = tabSelected
        console.log(tabSelectedRef.current)
    }, [tabSelected])

    let data3: any = []
    data3 = localStorage.getItem('userinformation')
    data3 = JSON.parse(data3)
    sdmUserIdref.current = data3.userId

    const getshow = () => {
        getbespeak(false)
        getbespeak2(false)



        goto({
            sdmUserId: sdmUserIdref.current,
            eventId: eventId
        }).then((res) => {
            console.log(res)
            if (res.code == 200) {
                getgo(true)
                whether()
                businessCardRef.current = []
                setbusinessCard(businessCardRef.current)

                sysRef.current = []
                setsys(sysRef.current)

                currentRef.current = 0
                setcurrent(currentRef.current)
                papticipantsData(eventId)

                cusBgNotify('Successfully participated in the activity')
            } else {
                cusBgNotify(res.msg)
            }

        });
        document.body.style.overflow = 'auto'
    }


    const ScrollContext2 = () => {
        getbespeak(true)
        document.body.style.overflow = 'hidden';
    }


    const ScrollContext = () => {
        // getgo(true)
        getbespeak(false)
        document.body.style.overflow = 'auto'
    }

    const goBackPage = () => {
        window.history.back()
    }

    const cusBgNotify = (message: string) => {
        console.log(message)
        Toast.show(message);
    }

    const cusBgNotify2 = () => {

        // if (localStorage.getItem('lang') == 'zh') {
        //     Toast.show('当前活动已结束');
        // } else {
        //     Toast.show('The current activity has ended');
        // }
        Toast.show(t('Thecurrentactivityhasended'));
    }





    const [dragDistance, setDragDistance] = useState(0); // 记录拖动距离的状态变量

    const [dragDistance2, setDragDistance2] = useState(0);

    let dragDistanceRef = useRef(0)
    useEffect(() => {
        dragDistanceRef.current = dragDistance
    }, [dragDistance])

    let dragDistanceRef2 = useRef(0)
    useEffect(() => {
        dragDistanceRef2.current = dragDistance2
    }, [dragDistance2])

    const [initialXPosition, setinitialXPosition] = useState(0)

    const handleMouseMove = (event: any) => {
        if (!event.buttons || event.button !== 0) return; // 只有在鼠标左键被按住时才会触发拖动
        let ogListW = ogList.length * -90
        const currentXPosition = event.clientX; // 获取鼠标相对于页面左边界的位置
        const draggedDistance = currentXPosition - initialXPosition; // 计算拖动距离
        const draggedDistance2 = draggedDistance + dragDistanceRef2.current

        if (draggedDistance2 < 1 && draggedDistance2 > ogListW) {
            dragDistanceRef.current = draggedDistance2
            setDragDistance(dragDistanceRef.current);
        }
        // 更新拖动距离的状态变量
    };

    const handleMouseDown = (event: any) => {
        console.log(event.clientX)
        setinitialXPosition(event.clientX)
        window.addEventListener('mousemove', handleMouseMove); // 注册鼠标移动事件监听器
        window.addEventListener('mouseup', handleMouseUp); // 注册鼠标松开事件监听器
    };

    const handleMouseUp = () => {
        dragDistanceRef2.current = dragDistanceRef.current
        setDragDistance2(dragDistanceRef2.current)
        window.removeEventListener('mousemove', handleMouseMove); // 移除鼠标移动事件监听器
        window.removeEventListener('mouseup', handleMouseUp); // 移除鼠标松开事件监听器
    };




    const scrollEvent = debounce(() => {
        let html = document.documentElement || document.body
        if (html.scrollTop >= html.scrollHeight - html.clientHeight - 100) {
            if (tabSelectedRef.current == 0) {
                // if (totalref.current > papticipant.length) {
                if (businessCardRef.current.length > 0 || sysRef.current.length > 0) {
                    papticipantsData(eventId)
                } else {
                    setHasMore(false)
                }

                // } else {
                //     setHasMore(false)
                // }
            } else {
                if (totalref.current > upcoming.length) {
                    // getDate3(typesRef.current)
                    getDate3(typesRef.current)
                } else {
                    setHasMore(false)
                }
            }
        }
    }, 500)

    const [hasMore, setHasMore] = useState(true)

    const Jumptobusinesscard = (id: any) => {


        if (id === null) {
            Toast.show(t('Nobusinesscard'));
        } else {
            const url = cardurl + '?st=sdn&id=' + id + '&event=' + event.eventId
            console.log(url, '111')
            // const url = `https://businesscard.web3-tp.net/detail?st=sdn&id=cb6c9a0f0e6a4a0198c15ad1eb88b850`
            window.location.assign(url);

        }

    }

    const [whetherdata, setwhether] = useState(0)

    const whether = async () => {
        await getwhether({
            sdmUserId: sdmUserIdref.current,
            eventId: eventId
        }).then((res) => {
            setwhether(res.data.eventNumber)
            getgo(res.data.go)
        })
    }






    return <div style={{ backgroundColor: "#0E1114", color: '#fff', position: 'relative' }}>
        {/* {
            whitescreen&&<div style={{height:'100%',width:'100%',zIndex:99999,backgroundColor:'#000',position}}></div>
        } */}
        {LOADING && <div style={{ width: '100%', height: '100vh', backgroundColor: '#000', zIndex: 99999, position: 'fixed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <IconFont name={Loading2} size="80" style={{ transform: `rotate(${transformdeg}deg)` }} />
        </div>

        }

        {bespeak && <div style={{ backgroundColor: '#000', width: '100%', height: '100%', zIndex: 1000, opacity: 0.5, position: 'absolute' }}>
        </div>}
        {bespeak && <div style={{
            alignItems: 'center', backgroundColor: '#37383D', width: '100%', zIndex: 1001, position: 'fixed', bottom: '0',
            borderTopRightRadius: '20px', borderTopLeftRadius: '20px'
        }}>
            <div style={{ height: '64px' }}>
                <div style={{ color: '#BABBBE', lineHeight: '64px', textAlign: 'center', fontSize: '15px', fontWeight: 500 }}>{t('Schedulepreview')}</div>
            </div>
            {
                activity.length > 0 ?
                    <div style={{ overflow: 'hidden', height: '55vh', width: '105vw' }}>
                        {/* <div style={{ overflow: 'auto', height: '100%', overflowY: 'scroll' }}> */}
                        <div style={{ height: '100%', overflowY: 'scroll' }}>
                            {
                                activity.map((item: any, index: any) =>
                                    <div key={index}  >
                                        <div style={{
                                            borderLeft: '10px solid',
                                            borderLeftColor: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'),
                                            color: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'),
                                            backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
                                        }} >
                                            <div style={{ margin: 10, display: 'flex', flexDirection: 'row' }}>
                                                <div style={{ fontSize: '12px', lineHeight: '14px', height: '14px', fontWeight: 500, marginRight: '10px', color: '#ffF' }}>
                                                    {/* {item.eventEndTime} */}
                                                    {item.time}
                                                </div>
                                                <div style={{ fontSize: '12px', lineHeight: '14px', height: '14px', fontWeight: 500 }}>{item.status}</div>
                                            </div>
                                            <div style={{ fontSize: '16px', lineHeight: '19px', height: '19px', fontWeight: 600, color: '#ffF', marginLeft: '10px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '65vw' }}>
                                                {item.eventName}
                                            </div>
                                            <Link to={`/plat2?longitude=${item.longitude}&latitude=${item.latitude}&eventLocation=${item.eventLocation}&eventName=${item.eventName}&time=${item.time}&eventId=${item.eventId}`}
                                                style={{ color: '#FFF', textDecorationLine: 'none' }}
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', height: '14px', margin: '10px' }}>
                                                        <img src={require("../../static/img/ph_map-pin2.png")} style={{ width: '14px', height: '14px', justifyContent: 'center' }}></img>
                                                        <div style={{
                                                            fontSize: '12px', lineHeight: '14px', fontWeight: 500, color: '#BCAFFF',
                                                            marginLeft: '5px', borderColor: '#BCAFFF', borderBottomWidth: 1, overflow: 'hidden', whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis', width: '65vw'
                                                        }}>
                                                            {item.eventLocation}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        {index != activity.length - 1 && <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px', marginLeft: '50px', marginBottom: '10px', marginRight: '50px' }}>
                                            <div style={{ marginRight: '10px' }}>
                                                <div style={{ height: 6, width: 6, backgroundColor: '#38CA9F', borderRadius: '3px', marginTop: '-2.5px' }}></div>
                                                <div style={{ height: '100%', borderLeft: '1px dashed #38CA9F', marginLeft: '2px' }}></div>
                                                <div style={{ height: 6, width: 6, backgroundColor: '#38CA9F', borderRadius: '3px', marginTop: '-2.5px' }}></div>
                                            </div>
                                            {/* <div style={{ color: '#38CA9F', textAlign: 'center', margin: '5px', fontSize: '12px', flexWrap: 'wrap' }}>
                                                {t('InternationalTravelPlanyouritinerarywell')}
                                            </div> */}

                                            {
                                                activity[index].eventCountry != activity[index + 1].eventCountry ? <div style={{ color: '#38CA9F', textAlign: 'center', margin: '5px', fontSize: '12px', flexWrap: 'wrap' }}>
                                                    {t('InternationalTravelPlanyouritinerarywell')}
                                                </div> : <div style={{ color: '#38CA9F', textAlign: 'center', margin: '5px', fontSize: '12px', flexWrap: 'wrap', height: '20px' }}>

                                                </div>
                                            }
                                        </div>}


                                    </div>

                                )
                            }
                        </div>
                    </div> : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                        <img src={require("../../static/img/Frame.png")} style={{ width: '206px', height: '158px', margin: '20px' }} alt="" />
                        <span style={{ fontSize: '16px', fontWeight: 500, height: '22.5px', lineHeight: '22.5px' }}> There are currently no itinerary conflicts</span>
                    </div>
            }
            <div style={{ display: 'flex', flexDirection: 'row', margin: '20px', marginTop: '40px' }}>
                <div style={{ flex: 1, alignItems: 'center', marginRight: '10px' }}>
                    <div style={{
                        backgroundColor: '#45474D', height: '48px', lineHeight: '48px',
                        borderRadius: '10px', textAlign: 'center', fontSize: '16px', fontWeight: 500, color: '#FFF', cursor: 'pointer'
                    }} onClick={() => ScrollContext()}>{t('Cancel')}</div>
                </div>
                <div style={{ flex: 1, alignItems: 'center', marginLeft: '10px' }}>
                    <div style={{
                        backgroundColor: '#735BF2', height: '48px', lineHeight: '48px',
                        borderRadius: '10px', textAlign: 'center', fontSize: '16px', fontWeight: 500, color: '#FFF', cursor: 'pointer'
                    }} onClick={() => getshow()}>{t('Iwillgo')}</div>
                </div>
            </div>
        </div>}

        {/* <div style={{ backgroundImage: `url(${event.eventBanner})`, width: '100%',height:'100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}> */}
        <div style={{
            backgroundImage: `url(${event.eventBanner})`, backgroundSize: '100%,100%', backgroundRepeat: 'no-repeat', borderTopRightRadius: '20px',
            borderTopLeftRadius: '20px', position: 'relative'
        }}>

            <div style={{ backgroundImage: 'linear-gradient(to top,#0E1114, rgba(255, 255, 255, 0.1))' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <img src={require("../../static/img/xljt.png")} style={{ width: '24px', height: '24px', marginTop: '20px', marginLeft: '10px', cursor: 'pointer' }} onClick={() => goBackPage()}></img>
                </div>
                <div style={{ marginLeft: '20px' }}>
                    {
                        tit ? <div style={{
                            color: '#FFFFFF', fontSize: '32px', fontWeight: 700, marginTop: '40px', overflow: 'hidden',whiteSpace: 'nowrap'
                            , textOverflow: 'ellipsis', width: '95%'
                        }} onClick={() => settit(false)}>{event.eventName}</div> : <div style={{
                            color: '#FFFFFF', fontSize: '32px', fontWeight: 700, marginTop: '40px', width: '95%', wordWrap: 'break-word', whiteSpace: 'normal'
                        }} onClick={() => settit(true)}>{event.eventName}</div>
                    }

                    <div style={{
                        color: '#FFFFFF', fontSize: '14px', marginTop: '15px', display: 'flex',
                        alignItems: 'center', marginLeft: '-5px'
                    }}>
                        <img src={require("../../static/img/Date2.png")} style={icon}></img><div style={{ paddingRight: '10px' }}>{event.time}</div>
                    </div>




                    <Link to={`/plat2?longitude=${event.longitude}&latitude=${event.latitude}&eventLocation=${event.eventLocation}&eventName=${event.eventName}&time=${event.time}&eventId=${event.eventId}`}
                        style={{ color: '#FFF', textDecorationLine: 'none' }}
                    >
                        <div style={{
                            color: '#FFFFFF', fontSize: '14px', marginTop: '10px', marginBottom: '10px', display: 'flex',
                            alignItems: 'center', marginLeft: '-5px'
                        }}>
                            <img src={require("../../static/img/ph_map-pin2.png")} style={icon}></img>
                            <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{event.eventLocation}</span>
                        </div>
                    </Link>
                    {
                        event.eventOrganizer && <div style={{
                            color: '#FFFFFF', fontSize: '14px', marginBottom: '10px', display: 'flex',
                            alignItems: 'center', marginLeft: '-5px'
                        }}>
                            <img src={require("../../static/img/yingyongguanliyuanguanli.png")} style={icon}></img><div style={{ paddingRight: '10px',width: '75vw', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',  }}>{event.eventOrganizer}({t('Organizer')})</div>
                        </div>
                    }

                    {
                         tit2 ? <div style={{
                            fontSize: '14px', color: '#BABBBE', marginRight: '20px', lineHeight: '25px', width: '95%', overflow: 'hidden',
                            textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', marginTop: '10px',

                        }} onClick={() => settit2(false)}>{event.eventDescribe}</div> :
                            <div style={{
                                fontSize: '14px', color: '#BABBBE', marginRight: '20px', lineHeight: '25px', wordWrap: 'break-word',
                                whiteSpace: 'normal', marginTop: '10rpx'
                            }} onClick={() => settit2(true)}>{event.eventDescribe}</div>
                    }

                </div>
            </div>

        </div>
        {ogList.length > 0 &&
            <div>
                <div style={{ marginLeft: '20px', marginTop: '20px', color: '#BABBBE', fontSize: '14px' }} >
                    {t('Speaker')}
                </div>
                {/* {dragDistance}px */}
                {/* <div style={{ overflow: 'hidden', height: '150px' }} > */}
                {/* {
                    ogList.length > 3 ? <div id="scrollableDiv" style={{ display: 'flex', flexDirection: 'row', width: '100%', overflowX: 'scroll' }}>
                        {ogList.map((item: any, index: any) => <div style={{ margin: '20px' }} key={index} >
                            <img src={item.headImg} style={{ width: '90px', height: '90px', justifyContent: 'center', borderRadius: '45px', display: item.headImg ? 'block' : 'none' }}></img>
                            <div style={{ fontSize: '14px', height: '12px', lineHeight: '12px', color: "#fff", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogPosition}</div>
                            <div style={{ fontSize: '12px', height: '10px', lineHeight: '10px', color: "#999999", textAlign: 'center' }}>{item.ogName}</div>
                        </div>)}

                    </div> : <div id="scrollableDiv" style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        {ogList.map((item: any, index: any) => <div style={{ margin: '20px' }} key={index} >
                            <img src={item.headImg} style={{ width: '90px', height: '90px', justifyContent: 'center', borderRadius: '45px', display: item.headImg ? 'block' : 'none' }}></img>
                            <div style={{ fontSize: '14px', height: '12px', lineHeight: '12px', color: "#fff", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogPosition}</div>
                            <div style={{ fontSize: '12px', height: '10px', lineHeight: '10px', color: "#999999", textAlign: 'center' }}>{item.ogName}</div>
                        </div>)}

                    </div>
                } */}

                {

                    ogList.length > 3 ? <div style={{ display: 'flex', flexDirection: 'row', width: '100%', overflowX: 'scroll' }}>
                        {ogList.map((item: any, index: any) => <div style={{ margin: '20px' }} key={index} >
                            <img src={item.headImg.replace('http:','https:')} style={{ width: '90px', height: '90px', justifyContent: 'center', borderRadius: '45px', display: item.headImg ? 'block' : 'none' }}></img>
                            <div style={{ fontSize: '14px', height: '12px', lineHeight: '12px', color: "#fff", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogName}</div>
                            <div style={{ fontSize: '12px', height: '10px', lineHeight: '10px', fontWeight: 400, color: "#999999", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogCompany}</div>
                        </div>)}

                    </div> : <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        {ogList.map((item: any, index: any) => <div style={{ margin: '20px' }} key={index} >
                            <img src={item.headImg.replace('http:','https:')} style={{ width: '90px', height: '90px', justifyContent: 'center', borderRadius: '45px', display: item.headImg ? 'block' : 'none' }}></img>
                            <div style={{ fontSize: '14px', height: '12px', lineHeight: '12px', color: "#fff", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}> {item.ogName}</div>
                            <div style={{ fontSize: '12px', height: '10px', lineHeight: '10px', fontWeight: 400, color: "#999999", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogCompany}</div>
                        </div>)}

                    </div>
                }


                {/* </div> */}
                {/* <div style={{ overflow: 'hidden' }}  >
                    <div id="hansor" style={{ display: 'flex', flexDirection: 'row', width: '100%', transform: `translateX(${dragDistance}px)` }}>
                        {ogList.map((item: any, index: any) => <div style={{ margin: '20px' }} key={index} >
                            <img draggable="true" src={item.headImg} style={{ width: '90px', height: '90px', justifyContent: 'center', borderRadius: '45px', display: item.headImg ? 'block' : 'none' }}></img>
                            <div style={{ fontSize: '14px', height: '12px', lineHeight: '12px', color: "#fff", width: '90px', marginTop: '5px', marginBottom: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>{item.ogName}</div>
                            <div style={{ fontSize: '12px', height: '10px', lineHeight: '10px', color: "#999999", textAlign: 'center', width: '90px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.ogCompany}</div>
                        </div>)}
                    </div>
                </div> */}
            </div>
        }



        <div style={{ fontSize: '14px', color: '#9E8BFF', marginTop: '10px', marginLeft: '20px', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => Directions(event.officialWebsiteLink)}>{t('Learnmorefromofficialwebsite')}</div>

        <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '20px', flexWrap: 'wrap' }}>
            {event.state &&
                <div style={{ display: 'flex', flexDirection: 'row', height: '26px', lineHeight: '6px', marginTop: '10px' }}>
                    <div style={{ marginRight: '10px', borderRadius: '13px', color: '#fff', backgroundColor: '#FFFFFF4D', padding: '10px' }}>{event.state}</div>
                </div>

            }
            {event.keywords &&
                event.keywordsmap.map((item: any, index: any) => <div>{item &&
                    <div key={index} style={{ display: 'flex', flexDirection: 'row', height: '26px', lineHeight: '6px', marginTop: '10px' }}>
                        <div style={{ marginRight: '10px', borderRadius: '13px', color: '#fff', backgroundColor: '#FFFFFF4D', padding: '10px',maxWidth: '50vw', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', }}>{item}</div>
                    </div>}
                </div>
                )
            }


            {event.industryLabel &&
                <div style={{ display: 'flex', flexDirection: 'row', height: '26px', lineHeight: '6px', marginTop: '10px' }}>
                    <div style={{ marginRight: '10px', borderRadius: '13px', color: '#fff', backgroundColor: '#FFFFFF4D', padding: '10px' }}>{event.industryLabel}</div>
                </div>

            }

        </div>

        <div style={{ display: 'flex', flexDirection: 'row', margin: '20px', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', height: '24px' }}>
                    <img src={require("../../static/img/Vector2.png")} style={{
                        width: '12.5px',
                        height: '20px', alignItems: 'center'
                    }} ></img>
                    <div style={{ color: '#FFFFFF', fontSize: '24px', fontWeight: 700, lineHeight: '24px', marginLeft: '5px', marginRight: '5px' }}>
                        {/* {event.eventNumber} */}
                        {whetherdata ? whetherdata : 0}
                    </div>
                    <div style={{ color: '#FFFFFF', fontSize: '16px', lineHeight: '24px' }} >{t('peoplewillgo')}</div>
                </div>
                {/* <div style={{ display: 'flex', flexDirection: 'row', height: '18px', marginTop: '10px' }}>
                    <img src={require("../../static/img/majesticons_analytics-line.png")} style={{ width: '16px', height: '16px', marginRight: 5, alignItems: 'center' }} ></img>
                    <div style={{ color: '#BCAFFF', fontSize: '14px', lineHeight: '18px' }}>{t('Analytics')}</div>
                </div> */}
            </div>

            {!go ?
                <div style={{ width: '69px', height: '48px', backgroundColor: '#735BF2', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => ScrollContext2()}>
                    {/* <div style={{ color: '#fff', lineHeight: '48px', textAlign: 'center', fontWeight: 500 }}> +1 {t('GO')}</div> */}
                    <img src={require("../../static/img/ic_round-favorite.png")} style={{ width: '24px', height: '24px' }}></img>
                </div>
                : <div onClick={() => {
                    goto({
                        sdmUserId: sdmUserIdref.current,
                        eventId: eventId
                    }).then((res) => {
                        if (res.code == 200) {
                            // getgo(false)
                            // getDate()
                            whether()
                            currentRef.current = 0
                            setcurrent(currentRef.current)
                            businessCardRef.current = []
                            setbusinessCard(businessCardRef.current)

                            sysRef.current = []
                            setsys(sysRef.current)


                            papticipantsData(eventId)
                            cusBgNotify('Successfully cancelled participation in the event')

                        } else {
                            cusBgNotify(res.msg)
                        }

                    });
                }} style={{
                    display: 'flex', width: '69px', height: '48px', backgroundColor: '#9788E7', borderRadius: '10px',
                    flexDirection: 'row', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'
                }}>
                    {/* <img src={require("../../static/img/Select2.png")} style={{ width: '16px', height: '16px', marginRight: '10px' }}></img>
                    <div style={{ color: '#fff', lineHeight: '48px', textAlign: 'center', fontWeight: 500 }}>{t('GO')}</div> */}
                    <img src={require("../../static/img/Vector4x.png")} style={{ width: '24px', height: '24px' }}></img>
                </div>
            }


        </div>

        <div style={{ marginTop: '40px', marginBottom: '80px' }}>

            <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: "#0E1114", textAlign: 'center' }}>
                <div style={tabSelected == 1 ? bgc2 : bgc}>
                    <div style={{ width: '20px', backgroundColor: "#0E1114", height: '42px', borderBottomRightRadius: '10px' }}></div>
                </div>
                <div style={tabSelected == 0 ? tabbg : tabbgs} onClick={() => { getparentDate2() }}>
                    <div style={tabSelected == 0 ? tabs : tab}>{t('participants')}</div>
                </div>

                <div style={tabSelected == 1 ? tabbg : tabbgs} onClick={() => { getparentDate() }}>
                    <div style={tabSelected == 1 ? tabs : tab2}>{t('Sideevents')}</div>
                </div>
                <div style={tabSelected == 1 ? bgc : bgc2}>
                    <div style={{ width: '20px', height: '42px', backgroundColor: "#0E1114", borderBottomLeftRadius: '10px' }}></div>
                </div>
            </div>
            {tabSelected == 0 ? <div style={{ backgroundColor: '#202225', paddingBottom: '10px', paddingTop: '20px', overflow: 'hidden', width: '100vw', display: 'flex' }}>

                <div style={{ overflow: 'hidden', height: '40vh', width: '105vw', }}>
                    {businessCard.length > 0 || sys.length > 0 ?

                        <div style={{ height: '100%', overflowY: 'scroll', justifyContent: 'center' }}>
                            {
                                businessCard.map((item: any, index: any) => <div style={{ backgroundColor: "#202225" }}>
                                    <div style={{ alignItems: 'center', marginBottom: 10, position: 'relative', marginLeft: '20px', marginRight: '20px', }}>
                                        <div style={{ backgroundImage: `url(${item.bgimg ? item.bgimg.replace('http:','https:') : bg1})`, width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '18px' }}>

                                            <div style={{ backgroundImage: 'linear-gradient(to top, rgba(0, 0, 0, 0.3), rgba(255, 255, 255, 0.1))', borderRadius: '20px' }}>
                                                {/* onClick={() => Jumptobusinesscard(item.cardNo)} */}
                                                <a href={cardurl + '?st=sdn&id=' + item.cardNo + '&event=' + event.eventId}>

                                                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 20, paddingTop: '20px' }}>
                                                        {
                                                            item.userImg.length > 7 ? <img src={item.userImg} style={{ width: '72px', height: '72px', borderRadius: '18px', border: '4px solid #000', boxShadow: '5px 5px #000' }} ></img> :
                                                                <div style={{
                                                                    width: '72px', height: '72px', lineHeight: '72px', borderRadius: '18px', border: '4px solid #000', boxShadow: '5px 5px #000',
                                                                    textAlign: 'center', backgroundColor: item.color ? item.color : '#ffaa7f', fontSize: '28px'
                                                                }}> {item.userName != null ? item.userName.slice(0, 1).toUpperCase() : ''}</div>
                                                        }


                                                        <div style={{ marginLeft: 10 }}>
                                                            <div style={{ fontSize: '24px', fontWeight: 700, color: '#FFFFFF', marginBottom: 2 }}>{item.name}</div>
                                                            <div style={{ fontSize: '16px', fontWeight: 500, color: '#FFFFFF', marginBottom: 2 }} >{item.title}</div>
                                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                                <img src={require("../../static/img/mianxing-gongsi.png")} style={{ width: '14px', height: '14px' }} ></img>
                                                                <div style={{ fontSize: '12px', color: '#FFFFFF', lineHeight: '14px', marginLeft: 5 }}>{item.company}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {item.friend == 1 && <div style={{ position: 'absolute', top: 10, right: 10 }}>
                                                        <div style={{ backgroundColor: '#000', opacity: 0.5, height: '30px', borderRadius: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <img src={require("../../static/img/Vector4.png")} style={{ width: '14px', height: '14px', marginLeft: 8, marginRight: 8 }} ></img>
                                                            <div style={{ color: '#FFF', lineHeight: '30px', fontSize: '15px', marginRight: 8 }}>{t('Friend')}</div>
                                                        </div>
                                                    </div>
                                                    }

                                                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                                        {
                                                            item.cardIndustries.map((item2: any, ind: number) => <div key={ind} style={{ backgroundColor: 'rgba(0,0,0,0.5)', height: '24px', borderRadius: '12px', borderColor: '#fff', borderWidth: 1, margin: '2.5px', border: '1px solid #fff ' }}>
                                                                <div style={{ color: '#FFF', lineHeight: '24px', fontSize: '12px', marginLeft: 8, marginRight: 8 }}>#{item2.industry}</div>
                                                            </div>

                                                            )
                                                        }

                                                    </div>
                                                </a>
                                            </div>






                                        </div>
                                    </div>
                                </div>


                                )
                            }
                            {
                                sys.map((item: any, index: any) => <div key={index} style={{
                                    display: 'flex', flexDirection: 'row',
                                    marginLeft: '20px', marginRight: '20px', marginTop: 5, marginBottom: 10, backgroundColor: '#2F3237', borderRadius: 10,
                                    justifyContent: 'space-between', alignItems: 'center', height: '64px'
                                }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', margin: '8px', alignItems: 'center' }} >
                                        {
                                            item.imgUrl.length > 7 ? <img src={item.imgUrl} style={{
                                                width: '48px', height: '48px', borderColor: '#a2a2a2',
                                                borderWidth: 4, borderRadius: 8
                                            }} ></img> :
                                                <div style={{
                                                    width: '48px', height: '48px', lineHeight: '48px',
                                                    textAlign: 'center', backgroundColor: item.color ? item.color : '#ffaa7f', fontSize: '20px', borderWidth: 4, borderRadius: 8
                                                }}> {item.sdmUserName != null ? item.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                        }

                                        <div style={{ marginLeft: 10 }}>
                                            <div style={{ fontWeight: 500, fontSize: '16px', color: '#FFFFFF', height: '24px', lineHeight: '24px' }}>
                                                {item.sdmUserName}
                                            </div>
                                            {
                                                item.walletDdressEtamask ? <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                                                    {item.walletDdressEtamask.toString().slice(0, 4)}...{item.walletDdressEtamask.toString().slice(item.walletDdressEtamask.toString().length - 4, item.walletDdressEtamask.toString().length)}

                                                </div> : <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                                                    {''}
                                                </div>
                                            }

                                        </div>
                                    </div>
                                    {
                                        item.friend == 1 && <div style={{ marginRight: 10 }} >
                                            <div style={{ backgroundColor: '#000', opacity: 0.5, height: '30px', borderRadius: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <img src={require("../../static/img/Vector4.png")} style={{ width: '14px', height: '14px', marginLeft: 8, marginRight: 8 }} ></img>
                                                <div style={{ color: '#FFF', lineHeight: '30px', fontSize: '15px', marginRight: 8 }}>{t('Friend')}</div>
                                            </div>
                                        </div>
                                    }
                                </div>)
                            }


                        </div> : <div style={{ padding: '20px', textAlign: 'center', height: '100%' }}>
                            {
                                showhasMore ?
                                    // <Loading direction="vertical" type="spinner">{t('LOADING')}</Loading> 
                                    <div style={{
                                        display: 'flex', flexDirection: 'row',
                                        marginBottom: 10, backgroundColor: '#2F3237', borderRadius: 10,
                                        justifyContent: 'space-between', alignItems: 'center',
                                    }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', margin: '8px', alignItems: 'center', padding: '5px' }} >
                                            <Skeleton animated style={{
                                                width: '48px', height: '48px', borderColor: '#a2a2a2',
                                                borderWidth: 4, borderRadius: 8
                                            }} />


                                            <div style={{ marginLeft: 10 }}>
                                                <Skeleton animated style={{ fontWeight: 500, fontSize: '16px', color: '#FFFFFF', height: '24px', width: '100px', borderRadius: '4px' }} />


                                                <Skeleton animated style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '19px', width: '80px', borderRadius: '4px', marginTop: '5px' }} />

                                            </div>
                                        </div>

                                    </div>
                                    : <div>{t('Nooneiscurrentlyparticipating')}</div>
                            }


                        </div>
                    }
                </div>

            </div> : <div style={{ backgroundColor: '#202225', paddingTop: '10px', }}>

                {
                    upcoming.length > 0 ?
                        <div>
                            <div style={{ alignItems: 'center', margin: '20px' }}>
                                <div style={{
                                    backgroundColor: '#202225',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}>
                                    <div style={{
                                        backgroundColor: '#35363B',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        flex: 1,
                                        marginRight: '20px',
                                        height: '32px',
                                        borderRadius: '5px',
                                        alignItems: 'center',
                                    }}>
                                        <div style={tabSelected2 == 0 ? Selected : notselected} onClick={() => {
                                            currentRef.current = 0; getupcoming([]); getSelecte2(0); getDate3(0);
                                        }}>
                                            <div>
                                                {t('Upcoming')}
                                            </div>
                                        </div>
                                        <div style={tabSelected2 == 1 ? Selected : notselected} onClick={() => {
                                            currentRef.current = 0; getupcoming([]); getSelecte2(1); getDate3(1)
                                        }}>
                                            <div>
                                                {t('Popular')}
                                            </div>
                                        </div>
                                    </div>

                                    <Link
                                        // to={{
                                        //     pathname: '/filters/' + event.eventId
                                        // }}
                                        to={`/filters?id=${event.eventId}&keywords=${JSON.stringify(event.keywordsmap)}`}
                                        style={{
                                            backgroundColor: '#35363B',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            // width: '170px',
                                            flex: 1,
                                            marginLeft: '20',
                                            height: '32px',
                                            borderRadius: '5px',
                                            alignItems: 'center',
                                            color: '#BABBBE',
                                            textDecorationLine: 'none'
                                        }}>
                                        <img src={require("../../static/img/guangqi_guolv.png")} style={{
                                            width: '16px',
                                            height: '16px',
                                            marginRight: 5
                                        }} />
                                        {t('Filters')}
                                    </Link>
                                </div>
                            </div>


                            <div style={{ display: 'flex', flexDirection: 'row', height: '16px', margin: 20, marginTop: 10 }}>
                                <div style={{ fontSize: '16px', fontWeight: 700, lineHeight: '16px', color: '#FFF', marginRight: '5px' }}>{total}</div>
                                <div style={{ fontSize: '14px', fontWeight: 400, lineHeight: '16px', color: '#FFF' }}> {t('Sideevents')}:</div>
                            </div>
                            {<div>
                                {
                                    upcoming.map((item: any, index: any) => <div>
                                        {
                                            total >= index + 1 &&
                                            // <Link to={{
                                            //     pathname: '/details/' + item.eventId
                                            // }}

                                            <Link to={`/details?eventId=${item.eventId}&eventeventId=${event.eventId}`}



                                                style={{ color: '#FFF', textDecorationLine: 'none' }}
                                                key={index}
                                            >
                                                <div style={{
                                                    backgroundColor: '#202225',
                                                    alignItems: 'center',
                                                    borderRadius: '20px',
                                                    padding: '20px',
                                                    paddingTop: 0
                                                }}>
                                                    <div style={{
                                                        width: '100%',
                                                        borderRadius: '20px',
                                                        backgroundColor: '#35363B',
                                                        position: 'relative',
                                                    }}>
                                                        <div style={{ height: '100px', overflow: 'hidden', }}>
                                                            <img src={item.eventBanner.replace('http:','https:')} style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                borderTopRightRadius: '20px',
                                                                borderTopLeftRadius: '20px',
                                                            }} alt="" />
                                                        </div>
                                                        {item.sideNumber != 0 && item.sideNumber &&

                                                            <div style={{
                                                                display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                                                                borderRadius: '30px', justifyContent: 'center', position: 'absolute', right: '8px', top: '8px',
                                                                paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                                            }}>
                                                                <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                                                                    width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                                                }} alt="" />
                                                                {item.sideNumber} {t('Sideevents')}
                                                            </div>
                                                        }

                                                        <div style={{ margin: 10 }}>

                                                            <div style={{ fontSize: '14px', fontWeight: 400, padding: '5px', width: '95%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#BABBBE' }}>{item.eventName}</div>
                                                            <div style={{ display: 'flex', marginBottom: '5px', }}>
                                                                <div style={{ fontSize: '14px', fontWeight: 400, padding: '5px', maxWidth: '60%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#BABBBE' }}>{event.eventName}</div>
                                                                {
                                                                    item.status && <div style={{ display: 'flex' }}>
                                                                        <div style={{ height: '4px', width: '4px', borderRadius: '50%', margin: '5px', marginTop: '12px', backgroundColor: '#BABBBE' }}></div>
                                                                        <div style={{ fontSize: '14px', fontWeight: 400, padding: '5px', color: '#BABBBE' }}> {item.status}</div>
                                                                    </div>
                                                                }


                                                            </div>

                                                            <div style={{
                                                                color: '#8E929D',
                                                                fontSize: '14px',
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            }}>
                                                                <img src={require("../../static/img/Date.png")} style={{
                                                                    marginLeft: '5px',
                                                                    marginRight: '5px',
                                                                    width: '14px',
                                                                    height: '14px'
                                                                }}></img>
                                                                {/* {item.eventEndTime} */}
                                                                {item.time}
                                                            </div>
                                                            <Link to={`/plat2?longitude=${item.longitude}&latitude=${item.latitude}&eventLocation=${item.eventLocation}&eventName=${item.eventName}&time=${item.time}&eventId=${item.eventId}`}
                                                                style={{ color: '#FFF', textDecorationLine: 'none' }}
                                                            >
                                                                <div style={{
                                                                    color: '#8E929D',
                                                                    fontSize: '14px',
                                                                    paddingTop: '5px',
                                                                    display: 'flex',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <img src={require("../../static/img/tdesign_location.png")} style={{
                                                                        marginLeft: '5px',
                                                                        marginRight: '5px',
                                                                        width: '14px',
                                                                        height: '14px',
                                                                        // paddingTop: '5px'
                                                                    }}></img>
                                                                    <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.eventLocation}</span>


                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                                                            <div style={{ display: 'flex' }}>
                                                                <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                                                                    {item.sdmUsers.map((item2: any, index: number) => <div>
                                                                        {
                                                                            index < 4 && <div>
                                                                                {
                                                                                    item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index} style={{
                                                                                        width: '24px', height: '24px', alignSelf: 'center', borderRadius: '12px',
                                                                                        position: 'absolute', left: index * 14, border: '2px solid #2F3039'
                                                                                    }} alt="" /> :
                                                                                        <div key={index} style={{
                                                                                            width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px',
                                                                                            position: 'absolute', left: index * 14, textAlign: 'center',
                                                                                            backgroundColor: item2.c, color: '#fff', fontSize: '16px', border: '2px solid #2F3039'
                                                                                        }} >{item2.sdmUserName != null ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                                                                }

                                                                            </div>
                                                                        }
                                                                        {
                                                                            index == 4 && <img src={require("../../static/img/Group.png")} key={index} style={{
                                                                                width: '24px',
                                                                                height: '24px', position: 'absolute', left: 56, alignSelf: 'center', borderRadius: '12px'
                                                                            }}></img>
                                                                        }
                                                                    </div>
                                                                    )}
                                                                </div>
                                                                {/* {item.people > 0 &&
                                                                    <div style={{fontSize:'12px',color:'#BABBBE',height:'24px',lineHeight:'24px'}}>
                                                                        {item.people}{t('friendswillgo')}
                                                                    </div>
                                                                } */}

                                                            </div>
                                                            {item.people > 0 &&
                                                                <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                                                                    <span style={{ marginRight: '5px' }}> {item.people}</span>{t('friendswillgo')}
                                                                </div>
                                                            }
                                                            <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                                                                <img src={require("../../static/img/Vector2.png")} style={{
                                                                    width: '12.5px',
                                                                    height: '20px', marginRight: '5px'
                                                                }} ></img>
                                                                {item.eventNumber ? item.eventNumber : 0}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>

                                        }
                                    </div>


                                    )
                                }
                            </div>}
                        </div> :
                        <div style={{ padding: '20px', textAlign: 'center', height: '100%' }}>
                            {
                                showhasMore ? <IconFont name={Loading2} size="80" style={{ transform: `rotate(${transformdeg}deg)` }} /> : <div> {t('Nomoreactivities')}</div>
                            }
                        </div>
                }
            </div>}
            <div >
                <Content4></Content4>
            </div>
        </div>

        {
            go ?
                <div style={{
                    position: 'fixed', bottom: 0, left: 0, width: '100%', backgroundColor: '#000', display: 'flex',
                    flexDirection: 'row', justifyContent: 'center', cursor: 'pointer'
                }}>
                    <div style={{ display: 'flex', margin: '16px', alignItems: 'center' }}>
                        {
                            // event.ticketingLink?
                            <div style={{
                                width: '285px', height: '48px', backgroundColor: '#FC774C',
                                color: '#FFF', fontSize: '16px', fontWeight: 500, textAlign: 'center', lineHeight: '48px', borderRadius: '10px',
                                display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center'
                            }} onClick={() => Directions(event.ticketingLink)}>
                                <img src={require("../../static/img/solar_ticket-bold.png")} style={{ width: '20px', height: '20px', marginRight: '10px' }}></img>
                                {t('Tickets')}</div>
                            //     : <div style={{
                            //     width: '285px', height: '48px', backgroundColor: '#FC774C',
                            //     color: '#FFF', fontSize: '16px', fontWeight: 500, textAlign: 'center', lineHeight: '48px', borderRadius: '10px',
                            //     display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center'
                            // }} onClick={() => Directions(event.ticketingLink)}>
                            //     <img src={require("../../static/img/solar_ticket-bold.png")} style={{ width: '20px', height: '20px', marginRight: '10px' }}></img>
                            //     {t('Registry')}</div>
                        }



                        <div onClick={() => getRoomInfo(event.registrationLink)} style={{
                            width: '48px', height: '48px', backgroundColor: '#50545A',
                            borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '20px', cursor: 'pointer'
                        }}>
                            <img src={require("../../static/img/Chat.png")} style={{ width: '20px', height: '20px' }}></img>
                        </div>
                    </div>

                </div>
                :
                <div style={{
                    position: 'fixed', bottom: 0, left: 0, width: '100%', backgroundColor: '#202225', display: 'flex',
                    flexDirection: 'row', justifyContent: 'center', cursor: 'pointer', alignItems: 'center'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '16px', cursor: 'pointer' }}>
                        <div onClick={() => getRoomInfo(event.registrationLink)} style={{
                            width: '350px', height: '48px', backgroundColor: '#FC774C',
                            color: '#FFF', fontSize: '16px', fontWeight: 500, textAlign: 'center', lineHeight: '48px', borderRadius: '10px',
                            display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center'
                        }}>  <img src={require("../../static/img/Chat.png")} style={{ width: '20px', height: '20px', marginRight: '10px' }}></img>
                            {t('Joingroupchat')}
                        </div>

                    </div>
                </div>
        }

        {/* {
            tabSelected == 1 && <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        } */}



    </div>
};




function Content4() {
    const params = useParams()

    const [search, setsearch] = useSearchParams()
    const [eventId, seteventId] = useState(search.get("eventId"));
    // const [recommendationsdata, setrecommendations] = useState([]) as any;
    const [nearby, setnearby] = useState('') as any;
    const [similarAttendees, setsimilarAttendees] = useState('') as any;
    const [ft, setft] = useState(false);
    const getDate = () => {
        recommendations({
            // id: params.eventId,
            id: eventId,
            // id:159,
            distance: 50
        }).then((res) => {

            let data = geif()

            if (res.data.nearby) {
                res.data.nearby.time = gettime2(res.data.nearby.eventStartTime, res.data.nearby.eventEndTime)
                res.data.nearby.people = 0

                if (res.data.nearby.sdmUsers === null) {
                    res.data.nearby.sdmUsers = []

                } else {
                    res.data.nearby.sdmUsers.forEach((i: any) => {
                        i.c = color16()
                        i.imgUrl = i.imgUrl + ''
                    })
                }

                eventperson({
                    linUserIds: data,
                    eventId: res.data.nearby.eventId
                }).then((re) => {

                    if (re.data) {
                        res.data.nearby.people = re.data.friends
                    }

                    if (res.data.nearby.sdmUsers[0])
                            res.data.nearby.sdmUsers.forEach((item2: any) => {
                            if (item2.imgUrl == undefined || item2.imgUrl == null || item2.imgUrl == 'null' || item2.imgUrl == 'undefined')
                                item2.imgUrl = ''
                        })

                    setnearby(res.data.nearby)
                    setft(true)
                })
            }



            if (res.data.similarAttendees) {
                res.data.similarAttendees.time = gettime2(res.data.similarAttendees.eventStartTime, res.data.similarAttendees.eventEndTime)
                res.data.similarAttendees.people = 0
                if (res.data.similarAttendees.sdmUsers === null) {
                    res.data.similarAttendees.sdmUsers = []
                } else {
                    console.log('res.data.similarAttendees')
                    res.data.similarAttendees.sdmUsers.forEach((i: any) => {
                        i.c = color16()
                        i.imgUrl = i.imgUrl + ''
                    })
                }
                eventperson({
                    linUserIds: data,
                    eventId: res.data.similarAttendees.eventId
                }).then((re) => {
                    // setrecommendations(res.data)
                    if (re.data) {
                        res.data.similarAttendees.people = re.data.friends
                    }
                    
                    if (res.data.similarAttendees.sdmUsers[0])
                        res.data.similarAttendees.sdmUsers.forEach((item2: any) => {
                            if (item2.imgUrl == undefined || item2.imgUrl == null || item2.imgUrl == 'null' || item2.imgUrl == 'undefined')
                                item2.imgUrl = ''
                        })
                    setsimilarAttendees(res.data.similarAttendees)
                    setft(true)
                })
            }


        }
        );
    }

    const color16 = () => {
        var r = Math.floor(Math.random() * 256);
        var g = Math.floor(Math.random() * 256);
        var b = Math.floor(Math.random() * 256);
        // var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
        var color = 'rgb(' + r + ',' + g + ', ' + b + ')';
        let color2 = localStorage.getItem('randomcolor')
        return color
    }


    const geif = () => {
        const data: any = []
        let data2: any = []
        data2 = localStorage.getItem('getMyContacts')
        data2 = JSON.parse(data2)
        let Frienddata = data2 ? data2 : []
        if (Frienddata.length > 0) {

            data2.forEach((item: any) => {
                data.push(item.userId)
            })
        }
        return data
    }



    let [country, setcountry] = useState(localStorage.getItem('country'))

    useEffect(() => {
        getDate()
    }, []);
    const { t } = useTranslation();

    return <div style={{ padding: '20px', backgroundColor: '#202225' }}>
        {
            ft &&
            <div>
                <div style={{ display: 'flex', height: '20px', margin: '20px' }}>
                    <img src={require("../../static/img/tuijian.png")} alt="" style={{ height: '20px', width: '20px', marginRight: '5px' }} />
                    <div style={{ height: '20px', lineHeight: '20px' }}>{t('Recommendedtoyou')}</div>
                </div>

                {
                    nearby.eventId && <div>
                        {/* {
                        
                        } */}

                        <Link to={`${nearby.eventPid ==0?'/eventdetails2':'/Details'}?eventId=${nearby.eventId}&country=${country}`
                        }
                            style={{ color: '#FFF', textDecorationLine: 'none', }}

                        >
                            <div style={{
                                backgroundColor: '#202225',
                                alignItems: 'center',
                                // position: 'relative',
                                borderRadius: '20px',
                                // padding: '20px',
                                marginTop: '10px',
                                paddingTop: 0
                            }}>
                                <div style={{
                                    width: '100%',
                                    borderRadius: '20px',
                                    backgroundColor: '#35363B',
                                    position: 'relative',
                                }}>
                                    <div style={{ height: '100px', overflow: 'hidden', }}>
                                        <img src={nearby.eventBanner.replace('http:','https:')} style={{
                                            width: '100%',
                                            borderTopRightRadius: '20px',
                                            borderTopLeftRadius: '20px',
                                        }} alt="" />
                                        {
                                            nearby.eventCountry && <div style={{
                                                display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                                                borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                                right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                            }}>
                                                <img src={require("../../static/img/Vector3.png")} style={{
                                                    width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                                }} alt="" />
                                                {/* {nearby.eventCountry} */}
                                             {t('Nearby')}
                                            </div>
                                        }

                                    </div>
                                    {nearby.sideNumber != 0 && nearby.sideNumber &&

                                        <div style={{
                                            display: 'flex', height: '30px', lineHeight: '30px',
                                            backgroundColor: '#212327', borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                            right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                        }}>
                                            <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                                                width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                            }} alt="" />
                                            {nearby.sideNumber} {t('Sideevents')}
                                        </div>
                                    }


                                    <div style={{ margin: 10 }}>
                                        {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, }}>{t('NYCFallEvents')}</div> */}
                                        <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '95%' }}>{nearby.eventName}</div>

                                        <div style={{
                                            color: '#8E929D',
                                            fontSize: '14px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            <img src={require("../../static/img/Date.png")} style={{
                                                marginLeft: '5px',
                                                marginRight: '5px',
                                                width: '14px',
                                                height: '14px'
                                            }}></img> {nearby.time}
                                            {/* {t('6November-7November')} */}
                                        </div>
                                        <Link to={`/plat2?longitude=${nearby.longitude}&latitude=${nearby.latitude}&eventLocation=${nearby.eventLocation}&eventName=${nearby.eventName}&time=${nearby.time}&eventId=${nearby.eventId}`}
                                            style={{ color: '#FFF', textDecorationLine: 'none' }}
                                        >
                                            <div style={{
                                                color: '#8E929D',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                paddingTop: '5px'
                                                , overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'
                                            }}>
                                                <img src={require("../../static/img/tdesign_location.png")} style={{
                                                    marginLeft: '5px',
                                                    marginRight: '5px',
                                                    width: '14px',
                                                    height: '14px',
                                                    // paddingTop: '5px'
                                                }}></img>
                                                <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{nearby.eventLocation}</span>
                                                {/* {t('NewYork,UnitedStates')} */}
                                            </div>
                                        </Link>
                                    </div>
                                    <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                                        <div style={{ display: 'flex' }}>
                                            <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                                                {/* //待定 */}


                                                {nearby.sdmUsers.map((item2: any, index: number) => <div>
                                                    {
                                                        index < 4 && <div>
                                                            {
                                                                item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index} style={{
                                                                    width: '24px', height: '24px', alignSelf: 'center', borderRadius: '12px'
                                                                    , position: 'absolute', left: index * 14, border: '2px solid #2F3039'
                                                                }} alt="" /> :
                                                                    <div key={index} style={{
                                                                        width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px',
                                                                        position: 'absolute', left: index * 14, textAlign: 'center',
                                                                        backgroundColor: item2.c, color: '#fff', border: '2px solid #2F3039', fontSize: '16px'
                                                                    }} >{item2.sdmUserName ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                                            }

                                                        </div>
                                                    }
                                                    {
                                                        index == 4 && <img src={require("../../static/img/Group.png")} key={index} style={{
                                                            width: '24px', height: '24px',
                                                            position: 'absolute', left: 56, alignSelf: 'center', borderRadius: '12px'
                                                        }}></img>
                                                    }
                                                </div>
                                                )}
                                            </div>
                                            {/* {item.people > 0 &&
                              <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px' }}>
                                  {item.people}{t('friendswillgo')}
                              </div>
                          } */}

                                        </div>
                                        {nearby.people > 0 &&
                                            <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                                                <span style={{ marginRight: '5px' }}> {nearby.people}</span>{t('friendswillgo')}
                                            </div>
                                        }
                                        <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                                            <img src={require("../../static/img/Vector2.png")} style={{
                                                width: '12.5px',
                                                height: '20px', marginRight: '5px'
                                            }} ></img>
                                            {nearby.eventNumber ? nearby.eventNumber : 0}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>

                }

                {
                    similarAttendees.eventId && <Link to={`${similarAttendees.eventPid==0?'/eventdetails2':'/Details'}?eventId=${similarAttendees.eventId}&country=${country}`
                    }
                        style={{ color: '#FFF', textDecorationLine: 'none', }}

                    >
                        <div style={{
                            backgroundColor: '#202225',
                            alignItems: 'center',
                            // position: 'relative',
                            borderRadius: '20px',
                            // padding: '20px',
                            marginTop: '10px',
                            paddingTop: 0
                        }}>
                            <div style={{
                                width: '100%',
                                borderRadius: '20px',
                                backgroundColor: '#35363B',
                                position: 'relative',
                            }}>
                                <div style={{ height: '100px', overflow: 'hidden', }}>
                                    <img src={similarAttendees.eventBanner.replace('http:','https:')} style={{
                                        width: '100%',
                                        borderTopRightRadius: '20px',
                                        borderTopLeftRadius: '20px',
                                    }} alt="" />

                                    <div style={{
                                        display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                                        borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                        right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                    }}>
                                        <img src={require("../../static/img/Vector2.png")} style={{
                                            width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                        }} alt="" />
                                        {t('similarAttendees')}
                                    </div>


                                </div>
                                {similarAttendees.sideNumber != 0 && similarAttendees.sideNumber &&

                                    <div style={{
                                        display: 'flex', height: '30px', lineHeight: '30px',
                                        backgroundColor: '#212327', borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                        right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                    }}>
                                        <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                                            width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                        }} alt="" />
                                        {similarAttendees.sideNumber} {t('Sideevents')}
                                    </div>
                                }


                                <div style={{ margin: 10 }}>
                                    {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, }}>{t('NYCFallEvents')}</div> */}
                                    <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, overflow: 'hidden', textOverflow: 'ellipsis',whiteSpace: 'nowrap',width: '95%' }}>{similarAttendees.eventName}</div>
                                    <div style={{
                                        color: '#8E929D',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <img src={require("../../static/img/Date.png")} style={{
                                            marginLeft: '5px',
                                            marginRight: '5px',
                                            width: '14px',
                                            height: '14px'
                                        }}></img> {similarAttendees.time}
                                        {/* {t('6November-7November')} */}
                                    </div>
                                    <Link to={`/plat2?longitude=${similarAttendees.longitude}&latitude=${similarAttendees.latitude}&eventLocation=${similarAttendees.eventLocation}&eventName=${similarAttendees.eventName}&time=${similarAttendees.time}&eventId=${similarAttendees.eventId}`}
                                        style={{ color: '#FFF', textDecorationLine: 'none' }}
                                    >
                                        <div style={{
                                            color: '#8E929D',
                                            fontSize: '14px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingTop: '5px'
                                            , overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'
                                        }}>
                                            <img src={require("../../static/img/tdesign_location.png")} style={{
                                                marginLeft: '5px',
                                                marginRight: '5px',
                                                width: '14px',
                                                height: '14px',
                                                // paddingTop: '5px'
                                            }}></img>
                                            <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{similarAttendees.eventLocation}</span>
                                            {/* {t('NewYork,UnitedStates')} */}
                                        </div>
                                    </Link>
                                </div>
                                <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                                            {/* //待定 */}
                                            {similarAttendees.sdmUsers.map((item2: any, index: number) => <div>
                                                {
                                                    index < 4 && <div>
                                                        {
                                                            item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index} style={{
                                                                width: '24px', height: '24px', alignSelf: 'center', borderRadius: '12px'
                                                                , position: 'absolute', left: index * 14, border: '2px solid #2F3039'
                                                            }} alt="" /> :
                                                                <div key={index} style={{
                                                                    width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px',
                                                                    position: 'absolute', left: index * 14, textAlign: 'center',
                                                                    backgroundColor: item2.c, color: '#fff', border: '2px solid #2F3039', fontSize: '16px'
                                                                }} >{item2.sdmUserName ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                                        }

                                                    </div>
                                                }
                                                {
                                                    index == 4 && <img src={require("../../static/img/Group.png")} key={index} style={{
                                                        width: '24px', height: '24px',
                                                        position: 'absolute', left: 56, alignSelf: 'center', borderRadius: '12px'
                                                    }}></img>
                                                }
                                            </div>
                                            )}
                                        </div>
                                        {/* {item.people > 0 &&
                                                <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px' }}>
                                                    {item.people}{t('friendswillgo')}
                                                </div>
                                            } */}

                                    </div>
                                    {similarAttendees.people > 0 &&
                                        <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                                            <span style={{ marginRight: '5px' }}> {similarAttendees.people}</span>{t('friendswillgo')}
                                        </div>
                                    }
                                    <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                                        <img src={require("../../static/img/Vector2.png")} style={{
                                            width: '12.5px',
                                            height: '20px', marginRight: '5px'
                                        }} ></img>
                                        {similarAttendees.eventNumber ? similarAttendees.eventNumber : 0}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                }


                {/* )
                } */}
            </div>
        }

    </div>
}




export default EventDetails;